import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import { FaPlus } from "react-icons/fa";
import AddPostModal from "./AddPostModal";
import Post from "./Post";
import LoginModal from "./LoginModal";
import UpdateUserModal from "./UpdateUserModal";
import SocialMediaPopup from "./SocialMediaPopUp";
import CustomImageSlider from "./CustomImageSlider";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";

const SpecificCategory = ({ activeCategory, setActiveCategory }) => {
  const [showModal, setShowModal] = useState(false);
  const [posts, setPosts] = useState([]);
  const { alias } = useParams(); // Use alias instead of category_key
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);
  const [showSocialMediaModal, setShowSocialMediaModal] = useState(false);
  const [username, setUsername] = useState(null);
  const [isAddPostTriggered, setIsAddPostTriggered] = useState(false);
  const [needsUsernameUpdate, setNeedsUsernameUpdate] = useState(false); 
  const [banners, setBanners] = useState([])
//   {
//     banner_image : "https://www.garbhsanskarguru.com//assets/image/banner_image/66a085813a6b91721795969.jpeg",
//     redirection_link : "http://localhost/community-project/public/assets/image/community_post_image/6697b4efb41a21721218287.jpeg"
//   },
//   {
//     banner_image : "https://www.garbhsanskarguru.com//assets/image/banner_image/66a085ad9655f1721796013.jpeg",
//     redirection_link : "https://www.garbhsanskarguru.com//assets/image/community_post_image/6699ff24c686e1721368356.jpeg"
//   },
//   {
//     banner_image : "https://www.garbhsanskarguru.com//assets/image/banner_image/66a085bdb5be31721796029.jpeg",
//     redirection_link : "http://localhost/community-project/public/assets/image/community_post_image/6697b4efb41a21721218287.jpeg"
//   }
// ])
  const observer = useRef();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userKey = localStorage.getItem("user_key");
    console.log('alias: ',alias);
    setIsAuthenticated(token && userKey);
    const storedUsername = localStorage.getItem("username");
    setUsername(storedUsername);
    const shouldShowModal = localStorage.getItem("showModal") === "true";
    if (shouldShowModal) {
      if (!storedUsername) {
        setShowUpdateUserModal(true);
      } else {
        setShowModal(true);
      }
      localStorage.removeItem("showModal");
    }
    fetchCategories();
    fetchPosts(1,alias)
  }, []);

  useEffect(() => {
    if (activeCategory==="my-posts") {
      setPosts([]);
      setCurrentPage(1);
      fetchPosts(1, activeCategory);
    }
  }, [activeCategory]);

  useEffect(() => {
    if (currentPage > 1) {
      activeCategory==="my-posts" ? fetchPosts(currentPage, activeCategory) : fetchPosts(currentPage, alias);
    }
  }, [currentPage]);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/community-categories`
      );
      // console.log(response.data.data);
      if (response.data && response.data.categories)
        setCategories(response.data.categories);
      if (response.data && response.data.banners)
        setBanners(response.data.banners);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
    setLoading(false);
  };

  const fetchPosts = async (page, categoryAlias) => {
    setIsLoading(true);
    setLoading(true);
    const key = localStorage.getItem("user_key");
    let API_URL;
    if (activeCategory === "my-posts")
      API_URL = `${process.env.REACT_APP_API_BASE_URL}/community-user/${key}/posts`;
    else
      API_URL = `${process.env.REACT_APP_API_BASE_URL}/community-posts/categories/${categoryAlias}`;
    try {
      const response = await axios.get(API_URL, {
        params: {
          page,
        },
      });
      if (response.data?.data?.data) {
        const newPosts = response.data.data.data
        // .filter(post => {
        //   // Only include posts that are approved or belong to the current user
        //   return (post.isApproved || post.user_key === key);
        // });
        setPosts((prevPosts) => [...prevPosts, ...newPosts]);
        setLastPage(response.data.data.last_page);
        // setActiveCategory(response.data.category_key);
      }
    } catch (error) {
      NotificationManager.error(
        "Error fetching posts! Please try again!",
        "Error"
      );
    } finally {
      setIsLoading(false);
    }
    setLoading(false);
  };

  const handlePostDelete = (postKey) => {
    setPosts((prevPosts) => prevPosts.filter((post) => post.post_key !== postKey));
    // setPostCache((prevCache) => {
    //   const updatedCache = { ...prevCache };
    //   if (updatedCache[activeCategory]) {
    //     updatedCache[activeCategory].posts = updatedCache[activeCategory].posts.filter(
    //       (post) => post.post_key !== postKey
    //     );
    //   }
    //   return updatedCache;
    // });
  };

  const handleAddPost = (post) => {
    setPosts([post, ...posts]);
    setShowSocialMediaModal(true); 
  };

  const lastPostRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && currentPage < lastPage) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoading, currentPage, lastPage]
  );

  const handleAddPostClick = () => {
    if (isAuthenticated) {
      if (username) {
        setShowModal(true);
      } else {
        setShowUpdateUserModal(true);
      }
    } else {
      setIsAddPostTriggered(true);
      setShowLoginModal(true);
    }
  };

  const handleLoginSuccess = (token, userKey) => {
    setIsAuthenticated(true);
    localStorage.setItem("token", token);
    localStorage.setItem("user_key", userKey);
  
    // Check if username is set
    const storedUsername = localStorage.getItem("username");
    if (!storedUsername) {
      setNeedsUsernameUpdate(true);
    }
  
    setShowLoginModal(false);
  
    if (isAddPostTriggered) {
      setIsAddPostTriggered(false);
      localStorage.setItem("showModal", "true");
  
      if (!storedUsername) {
        setShowUpdateUserModal(true);
      } else {
        setShowModal(true);
      }
    }
  };  

  const handleUpdateUsername = (newUsername) => {
    NotificationManager.success("User updated successfully!", "Success");
  };

  const bannerImages = banners.map((banner) => ({
    // url: banner.banner_image,
    url: `https://www.garbhsanskarguru.com//assets/image/banner_image/${banner.banner_image}`,
    redirection_link: banner.redirection_link,
  }));

  const onClickBanner = (index) => {
    window.open(bannerImages[index].redirection_link, "_blank");
  };

  return (
    <Container>
      {loading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
      <Wrapper>
      <AddPostPlaceholder onClick={handleAddPostClick}>
          Write/Post something here...
        </AddPostPlaceholder>
      {!isLoading && posts.length === 0 ? (
          <NoPostsMessage>
            No posts available. Create a post to see posts.
          </NoPostsMessage>
        ) : (
          posts.map((post, index) => {
            if (posts.length === index + 1) {
              return (
                <div ref={lastPostRef} key={post.post_key}>
                  <Post
                    userName={post.user_name || "Unknown User"}
                    categoryName={post.category_name}
                    postTime={post.created_at || "Unknown Time"}
                    content={post.post_content || ""}
                    images={post.image_path ? [post.image_path] : []}
                    postKey={post.post_key}
                    profileImage={post.profile_image}
                    totalComments={post.total_comments}
                    totalReactions={post.total_reactions}
                    reactions={post.reaction_counts}
                    setShowLoginModal={setShowLoginModal}
                    activeCategory={activeCategory}
                    onDeletePost={handlePostDelete}
                  />
                  {index % 7 === 6 && banners?.length>0 && (
                    <CustomImageSlider
                    images={bannerImages}
                    autoPlay={true}
                    showBullets={true}
                  />
              )}
                </div>
              );
            } else {
              return (
                <>
                <Post
                  key={post.post_key}
                  userName={post.user_name || "Unknown User"}
                  categoryName={post.category_name}
                  postTime={post.created_at || "Unknown Time"}
                  content={post.post_content || ""}
                  images={post.image_path ? [post.image_path] : []}
                  postKey={post.post_key}
                  profileImage={post.profile_image}
                  totalComments={post.total_comments}
                  totalReactions={post.total_reactions}
                  reactions={post.reaction_counts}
                  setShowLoginModal={setShowLoginModal}
                  activeCategory={activeCategory}
                  onDeletePost={handlePostDelete}
                />
                {index % 7 === 6 && banners?.length>0 && (
                <CustomImageSlider
                images={bannerImages}
                autoPlay={true}
                showBullets={true}
              />
                )}
                </>
              );
            }
          })
        )}
        {isLoading && <p>Loading...</p>}
        {showModal && (
          <AddPostModal
            show={showModal}
            onClose={() => setShowModal(false)}
            onSubmit={handleAddPost}
            activeCategory={activeCategory}
            setActiveCategory={setActiveCategory}
            categories={categories}
          />
        )}
        {showLoginModal && (
          <LoginModal
            onClose={() => setShowLoginModal(false)}
            onLoginSuccess={handleLoginSuccess}
            onOtpVerificationSuccess={() => setShowUpdateUserModal(true)}
          />
        )}
        <UpdateUserModal
          show={showUpdateUserModal}
          onClose={() => setShowUpdateUserModal(false)}
          onSubmit={handleUpdateUsername}
        />
        {showSocialMediaModal && (
          <SocialMediaPopup
            showModal={showSocialMediaModal}
            handleCloseModal={() => setShowSocialMediaModal(false)}
          />
        )}
      </Wrapper>
      <AddPostButton onClick={handleAddPostClick}>
        <FaPlus /> Add post
      </AddPostButton>
      <NotificationContainer />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff; /* Adjust background color as needed */
  padding: 20px;
  min-height: 100vh;
  width: 90%;

  @media (max-width: 767px) {
    padding: 10px;
    width: 100%;
  }
`;

const AddPostPlaceholder = styled.div`
  padding: 15px;
  width: 400px;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  border: 1px solid #ced4da;
  border-radius: 25px;
  cursor: pointer;
  color: #495057;
  text-align: center;
  font-size: 16px;
  &:hover {
    background-color: #e9ecef;
  }

  @media (max-width: 767px) {
    width: calc(100% - 50px);
  }
`;

const BannerContainer = styled.div`
  margin: 20px 0;
  padding: 20px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 3px 3px 4px #a3b1c6, -5px -5px 15px #ffffff;
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;

  @media (max-width: 767px) {
    width: calc(100% - 40px);
    padding: 16px;
  }
`;

const AddPostButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #e75b82;
  color: #fff;
  border: none;
  border-radius: 8px; /* Set to rectangular with circular borders */
  padding: 10px;
  font-size: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-shadow: 3px 3px 4px #a3b1c6, -5px -5px 15px #ffffff;
  z-index:1000;
  svg {
    margin-right: 8px;
  }
`;

const NoPostsMessage = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-top: 20px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
`;


export default SpecificCategory;
